import PropTypes from 'prop-types';
import React from 'react';
import { Input, List, Typography, Icon, Pagination } from 'antd';
import { Button } from 'antd';
import { Tree } from 'element-react';
import { eventListener, LungSvgIcon, ReplaceTextIcon } from '../utils';
import { apis } from '../api/index.js';
const { Search } = Input;

const treeDataS = [
  { id: 0, parentId: 0, name: '个人知识库', fileFlag: true, child: [] },
  { id: 1, parentId: 0, name: '公共知识库', fileFlag: true, child: [] },
];
const productionId = '101';

class Knowledge extends React.Component {
  static propTypes = {
    history: PropTypes.object,
    leftHeight: PropTypes.number,
    setClickedKnowledgeInfo: PropTypes.func,
    form: PropTypes.object,
    state: PropTypes.number.isRequired,
  };

  state = {
    treeData: treeDataS,
    searchText: '',
    clickedKnowledgeInfo: [],
    treeList: [],
    total: 0,
    kPageSize: 30,
    treeClickCount: 0,
  };

  componentDidMount() {
    this.getKnowledgeTree();
  }
  //初始化树
  getKnowledgeTree = () => {
    const privateTree = Promise.resolve(apis.ctKnowledgeTree(true));
    const publicTree = Promise.resolve(apis.ctKnowledgeTree(false));
    Promise.all([privateTree, publicTree]).then(values => {
      const { treeData } = this.state;
      treeData[0].child = values[0].data;
      treeData[1].child = values[1].data;
      this.setState({ treeData });
    });
  };
  knowledgeDetail = (data, type) => {
    const { id } = data;
    if (data.fileFlag === false) {
      const { clickedKnowledgeInfo } = this.state;
      clickedKnowledgeInfo.push({ id, operation: type });
      this.setState({ clickedKnowledgeInfo });
      this.props.setClickedKnowledgeInfo(clickedKnowledgeInfo);
      apis.ctKnowledgeInfoById(id).then(res => {
        if (res.code === '0') {
          let { finding, impression } = res.data;
          let radiography =
            this.props.form.getFieldValue('radiographyDescription') || '';
          let diagnosis =
            this.props.form.getFieldValue('diagnosisDescription') || '';

          if (type === 'append') {
            this.props.form.setFieldsValue({
              radiographyDescription: radiography + finding + `\n`,
              diagnosisDescription: diagnosis + impression + `\n`,
            });
          } else if (type === 'replace') {
            this.props.form.setFieldsValue({
              radiographyDescription: finding + '\n',
              diagnosisDescription: impression + '\n',
            });
          } else if (type === 'replace_f') {
            this.props.form.setFieldsValue({
              radiographyDescription: finding + `\n`,
            });
          } else if (type === 'replace_i') {
            this.props.form.setFieldsValue({
              diagnosisDescription: impression + `\n`,
            });
          }

          const { state } = this.props;
          const pIdMap = { 11: '10019', 21: '10020', 26: '10020' };
          const eIdMap = {
            append: 'ns-006',
            replace: 'ns-007',
            replace_f: 'ns-008',
            replace_i: 'ns-009',
          };
          let [pageId, moduleId, elementId] = [
            pIdMap[state],
            'mk0003',
            eIdMap[type],
          ];
          elementId &&
            eventListener({ productionId, pageId, moduleId, elementId }, true);
        } else if (res.code === '1009') this.props.history.push('/login');
      });
    }
  };
  getOperateButtons = data => {
    if (data.fileFlag) return;
    return (
      <div className="tree-btns">
        <Button
          icon="plus"
          shape="circle"
          size="small"
          title="添加"
          onClick={() => this.knowledgeDetail(data, 'append')}
        ></Button>
        <Button
          icon="swap"
          shape="circle"
          size="small"
          title="全部替换"
          onClick={() => this.knowledgeDetail(data, 'replace')}
        ></Button>
        <Button
          shape="circle"
          size="small"
          title="替换影像所见"
          onClick={() => this.knowledgeDetail(data, 'replace_f')}
        >
          <LungSvgIcon />
        </Button>
        <Button
          shape="circle"
          size="small"
          title="替换诊断建议"
          onClick={() => this.knowledgeDetail(data, 'replace_i')}
        >
          <ReplaceTextIcon />
        </Button>
      </div>
    );
  };
  treeRenderContent = (nodeModel, data, store) => (
    <>
      <span className="file-icon">
        <Icon
          className={data.fileFlag ? '' : 'file'}
          type={data.fileFlag ? 'folder' : 'file'}
          theme="filled"
        />
        &nbsp;{data.name}
      </span>
      {this.getOperateButtons(data)}
    </>
  );
  getTreeList = async id => {
    let res = [];
    if (id === 0) res = await apis.ctKnowledgeTree(true);
    else if (id === 1) res = await apis.ctKnowledgeTree(false);
    else res = await apis.ctKnowledgeTree(undefined, id);

    return res.data;
  };
  loadNode = async (node, resolve) => {
    const { treeData } = this.state;
    if (node.level === 0) return resolve(treeData);
    else return resolve(await this.getTreeList(node.data.id));
  };
  filterTreeData = async value => {
    const { state } = this.props;
    let [pageId, moduleId, elementId] = ['', 'mk0003', 'ns-002'];
    if (state === 11) pageId = '10019';
    else if ([21, 26].includes(state)) pageId = '10020';
    pageId &&
      eventListener({ productionId, pageId, moduleId, elementId }, true);

    const size = this.state.kPageSize;
    const privateT = Promise.resolve(
      apis.ctKnowledgeList(true, value, 1, size)
    );
    const publicT = Promise.resolve(
      apis.ctKnowledgeList(false, value, 1, size)
    );
    Promise.all([privateT, publicT]).then(values => {
      const value1 = values[0].data.list || [];
      const value2 = values[1].data.list || [];
      this.setState({
        searchText: value,
        treeList: value1.concat(value2),
        total: values[1].data.total,
      });
    });
  };
  pageOnChange = page => {
    const { searchText, kPageSize } = this.state;
    const privateT = Promise.resolve(
      apis.ctKnowledgeList(true, searchText, page, kPageSize)
    );
    const publicT = Promise.resolve(
      apis.ctKnowledgeList(false, searchText, page, kPageSize)
    );
    Promise.all([privateT, publicT]).then(values => {
      const value1 = values[0].data.list || [];
      const value2 = values[1].data.list || [];
      this.setState({
        treeList: value1.concat(value2),
        total: values[1].data.total,
      });
    });
  };
  //知识库搜索结果
  knowledgeSearchResult = () => (
    <div className="knowledge-search-page">
      <List
        dataSource={this.state.treeList}
        renderItem={item => {
          const { searchText } = this.state;
          const len = searchText.length;
          const index = item.name.indexOf(searchText);
          let { name, fileFlag } = item;
          if (index > -1) {
            let left = name.substring(0, index);
            let center = name.substring(index, index + len);
            let right = name.substring(index + len);
            name = (
              <>
                {left}
                <Typography.Text mark>{center}</Typography.Text>
                {right}
              </>
            );
          }
          return (
            <div className={fileFlag ? 'title' : 'list'}>
              {!fileFlag && <Icon type="file-text" theme="filled" />}
              <List.Item className={fileFlag ? '' : 'cursor'}>
                {name}
                {this.getOperateButtons(item)}
              </List.Item>
            </div>
          );
        }}
      />
      <Pagination
        size="small"
        total={this.state.total}
        pageSize={this.state.kPageSize}
        onChange={this.pageOnChange}
      />
    </div>
  );
  onNodeExpand = nodeModel => {
    const { name } = nodeModel;
    const { state } = this.props;
    const pIdMap = { 11: '10019', 21: '10020', 26: '10020' };
    const eIdMap = { 个人知识库: 'ns-003', 公共知识库: 'ns-004' };
    let [pageId, moduleId, elementId] = [pIdMap[state], 'mk0003', eIdMap[name]];
    elementId &&
      eventListener({ productionId, pageId, moduleId, elementId }, true);
  };
  onNodeCollapse = nodeModel => {
    const { name } = nodeModel;
    const { state } = this.props;
    const pIdMap = { 11: '10019', 21: '10020', 26: '10020' };
    const eIdMap = { 个人知识库: 'ns-003', 公共知识库: 'ns-005' };
    let [pageId, moduleId, elementId] = [pIdMap[state], 'mk0003', eIdMap[name]];
    elementId &&
      eventListener({ productionId, pageId, moduleId, elementId }, true);
  };
  render() {
    const { leftHeight } = this.props;
    const { searchText } = this.state;
    const treeHeight = leftHeight - 70;
    const options = { children: 'child', label: 'name' };
    return (
      <div className="report-left" style={{ height: leftHeight }}>
        <Search
          placeholder="输入关键字按下Enter键搜索"
          onSearch={this.filterTreeData}
        />
        <div className="report-left-tree" style={{ height: treeHeight }}>
          {searchText !== '' && searchText.trim() !== '' ? (
            <>{this.knowledgeSearchResult()}</>
          ) : (
            <Tree
              ref={e => (this.tree = e)}
              className="filter-tree"
              options={options}
              nodeKey="id"
              defaultExpandAll={false}
              highlightCurrent={true}
              expandOnClickNode={false}
              renderContent={this.treeRenderContent}
              lazy
              load={this.loadNode}
              onNodeExpand={this.onNodeExpand}
              onNodeCollapse={this.onNodeCollapse}
            />
          )}
        </div>
      </div>
    );
  }
}

export default Knowledge;
